import { useState, useEffect } from 'react';
import { getBinLevelMeasurementOverrides } from './bin-level-measurements.js';

function useBinLevelMeasurementOverrides({ bin }) {
  const [measurementOverrides, setMeasurementOverrides] = useState();

  useEffect(() => {
    let mounted = true;

    if (!bin) {
      setMeasurementOverrides(undefined);
    } else {
      getBinLevelMeasurementOverrides(bin).then((...params) => {
        if (mounted) {
          setMeasurementOverrides(...params);
        }
      });
    }

    return () => {
      mounted = false;
    };
  }, [bin]);
  return measurementOverrides;
}

export default useBinLevelMeasurementOverrides;
